import React, { useCallback, useRef, useMemo, useEffect, useState } from 'react'
import { DatePicker, ConfigProvider } from 'antd'
import dayjs from 'dayjs'
import locale from 'antd/es/locale/ru_RU'
import { IDate } from './interface'

export function InputDateTime({ value, onChange, UISchema }: IDate) {
  const ref = useRef<any>()
  const [localValue, setLocalValue] = useState<any>({})

  const disabled = useMemo(() => Boolean(UISchema?.options?.disabled), [UISchema])
  const style = UISchema?.style

  useEffect(() => {
    setLocalValue(value)
  }, [value])

  const isDisabledDatePrev = useMemo(() => {
    return UISchema?.options?.isDisabledDatePrev ?? true
  }, [UISchema])

  const picker = useMemo(() => {
    return UISchema?.options?.picker ?? ''
  }, [UISchema])

  const disabledDate = useCallback(
    date => {
      if (typeof isDisabledDatePrev === 'string') {
        if (isDisabledDatePrev) {
          return dayjs(date).valueOf() < dayjs(isDisabledDatePrev).valueOf()
        }
      }
      if (isDisabledDatePrev) {
        return dayjs(date).valueOf() < dayjs().subtract(1, 'days').valueOf()
      }
      return false
    },
    [isDisabledDatePrev],
  )
  console.log({ disabledDate, isDisabledDatePrev })

  const handleChange = useCallback(
    nextValue => {
      onChange(nextValue && nextValue.toISOString && nextValue.toISOString())
    },
    [onChange, localValue],
  )

  const datePickerProps = {
    ref: ref,
    onChange: handleChange,
    format: 'DD.MM.YYYY HH:mm',
    showTime: { format: 'HH:mm' },
    value: localValue && dayjs(localValue),
    disabledDate: disabledDate,
    disabled: disabled,
    style: style,
    ...(picker && { picker: picker }),
  }

  return (
    <ConfigProvider locale={locale}>
      <DatePicker {...datePickerProps} />
    </ConfigProvider>
  )
}

export default InputDateTime
